export const WEB_SESSION_IDLE_TIMEOUT_MS = 10 * 60 * 1000;
export const WEB_SESSION_MAX_DURATION_MS = 12 * 60 * 60 * 1000;
export const WEB_SESSION_ACTIVITY_THROTTLE_MS = 1000;

export const WEB_SESSION_STARTED_AT_KEY = 'hereworks.webSession.startedAt';
export const WEB_SESSION_LAST_ACTIVITY_KEY = 'hereworks.webSession.lastActivity';
export const WEB_SESSION_EXPIRED_KEY = 'hereworks.webSession.expired';
